import { t } from "@superset-ui/core";

export const commonControlsConfig = {
  tooltipFormat: {
    type: 'TextControl',
    label: t('Tooltip Format'),
    description: t(
      'String template for tooltip format. Ex: {a} <br/>{b}: {c}' +
      '{a} for series name, {b} for area name, {c} for merging data.'
    ),
    renderTrigger: true,
  },
  geoJSON: {
    type: 'TextControl',
    label: t('GeoJSON'),
    description: t('GeoJSON format as string.'),
    renderTrigger: false
  },
  svgMap: {
    type: 'TextControl',
    label: t('SVG'),
    description: t('Map as an svg string.'),
    renderTrigger: false
  }
};
